/** Stable filter-operation wire IDs shared by Neptune and Pluto. */
export enum FilterOperation {
    contains = "8469962d-ef9b-4123-9a89-729e99ffe2f2",
    equals = "d75e2e16-5541-44a4-ad30-ce16bfc4dc8b",
    endsWith = "91fb3a4e-07cd-4460-9298-0042cbbff6a5",
    greaterThan = "7341a085-fff0-4b38-8f96-4de159a4f9bf",
    greaterThanEqualTo = "7456c07a-7a89-4868-b5e5-747d594c45e1",
    in = "f3a22693-5d10-4aad-8007-c5dfa9e62a3c",
    lessThan = "6626715d-7cf4-416e-8a14-b93a527d0b7a",
    lessThanEqualTo = "cd03ea72-50b8-44eb-80b2-ab9b7eb26fc2",
    notContains = "a2969633-0c47-4d6e-a26b-4a0055eb7db7",
    notEquals = "72a8470b-94dd-4d86-b2cb-48baaea0d180",
    startsWith = "1f73a693-0720-49f4-972f-5234910f7e82",
    isNull = "f2b8d6e9-1c7d-4e45-bf6a-8d1a4b5c7e96",
    isNotNull = "e1a7c5d8-0b6c-4d34-ae59-7c0f3a4b6d85",
}

/** Historical tracker alias; retained for existing requests. */
export const LEGACY_FILTER_OPERATION_IN = "b8c4d5e6-f7a8-4b9c-8d1e-2f3a4b5c6d7e";
